<template>
  <HelpCenterDialog
    #default="{ dialogBinds, backdropBinds }"
    :open="open"
    @close="onClose"
  >
    <HelpCenterTeleport to="#help-center-modals">
      <dialog
        class="help-center-modal__dialog"
        v-bind="dialogBinds"
      >
        <div
          class="help-center-modal__backdrop"
          v-bind="backdropBinds"
        />
        <div class="help-center-modal__wrap">
          <div class="help-center-modal__head">
            <slot name="head" />
          </div>
          <div class="help-center-modal__body">
            <slot name="body" />
          </div>
        </div>
      </dialog>
    </HelpCenterTeleport>
  </HelpCenterDialog>
</template>

<script setup>
import HelpCenterDialog from 'help-center/components/HelpCenterDialog'
import HelpCenterTeleport from 'help-center/components/HelpCenterTeleport'

const emit = defineEmits(['close'])

defineProps({
  open: {
    type: Boolean,
    required: true
  }
})

function onClose() {
  emit('close')
}
</script>

<style lang="scss">
@import 'help-center/mixins';

$margin: 16px;

.help-center-modal {
  &__dialog {
    @include help-center-dialog;
    @include help-center-scroll-trap-outer;

    align-items: center;
    justify-content: center;

    &[open] {
      display: flex;
    }
  }

  &__backdrop {
    @include help-center-backdrop;
    @include help-center-scroll-trap-inner;
  }

  &__wrap {
    display: flex;
    flex-direction: column;

    isolation: isolate;

    overflow: hidden;
    background: white;
    border-radius: 20px;

    margin: $margin;
    width: calc(100% - #{$margin*2});
    min-width: calc(var(--help-center-body-min-width) - #{$margin*2});
    max-width: 592px;
    max-height: calc(100% - #{$margin*2});

    @include help-center-breakpoint(md) {
      max-height: 90%;
    }
  }

  &__head {
    flex: none;
  }

  &__body {
    @include help-center-thin-scrollbar;
    flex: auto;
  }
}
</style>
